require('sass/brands/stores.petit-bateau.com/search/default.scss');
require('js/search-script.js');
